export const syneriseOrigins = ["b2c", "b2b"] as const;
export type SyneriseOrigin = (typeof syneriseOrigins)[number];

/**
 * Kanoniczny słownik wartości `nlsource` (PS-1676 — unifikacja zapisu zgód marketingowych).
 * Wartości pochodzą z dokumentu B2C; `vouchers_distribution` dodane dla dystrybucji voucherów B2B.
 * Dynamiczne `lp_<slug>` obsługiwane są osobno i nie są używane w B2B.
 */
export const syneriseNlSources = [
  "homepage_banner",
  "registration_form",
  "group_action",
  "checkout",
  "blog",
  "membership",
  "dashboard_reactivation",
  "single_results",
  "vouchers_distribution",
] as const;
export type SyneriseNlSource = (typeof syneriseNlSources)[number];

export const originTag = (origin: SyneriseOrigin) => `origin:${origin}` as const;
export const nlSourceTag = (nlSource: SyneriseNlSource) => `nlsource:${nlSource}` as const;

export const buildOriginNlSourceTags = (origin: SyneriseOrigin, nlSource: SyneriseNlSource): string[] => [
  originTag(origin),
  nlSourceTag(nlSource),
];
